module.exports = __webpack_public_path__ + "static/img/module_style_02.4a7c188.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ossmanage/module_style_02.png
// module id = Iv6K
// module chunks = 0